/** EPR Packaging SKU section — Shopify-app analog on the Lappa platform. */

export const PACKAGING_SKU_PATH = "/packaging-sku"
export const PACKAGING_SKU_CREATE_PATH = "/packaging-sku/create"

export function packagingSkuEditPath(packageId) {
  const id = String(packageId ?? "").trim()
  return id ? `/packaging-sku/${encodeURIComponent(id)}/edit` : PACKAGING_SKU_CREATE_PATH
}
